// The stored journal.md holds two completely independent pieces of content,
// saved by two unrelated flows: cohort-tab evidence (Daily Tasks, Concept
// Clinic, Hackathon, Show & Tell, Mock Interview — appended incrementally from
// CohortPilotPage) and the lesson-progress journal (rebuilt from scratch on
// every lesson-notes save in TrackRoadmapPage). Both used to call the same
// PUT /journal endpoint with a full-file replace — saving a lesson note
// silently wiped every cohort-tab entry ever logged, and vice versa, because
// neither save path knew the other's content existed.
//
// Wrapping each piece in its own marker section and only ever replacing *your
// own* section keeps the other one intact no matter what order saves happen
// in. The markers are HTML comments, so they render invisibly and don't
// collide with any `##`/`###` heading the markdown parsers key off.

const sectionStart = (key) => `<!-- journal-section:${key}:start -->`;
const sectionEnd = (key) => `<!-- journal-section:${key}:end -->`;

export function readJournalSection(existingMarkdown, sectionKey) {
  const existing = existingMarkdown || '';
  const start = sectionStart(sectionKey);
  const end = sectionEnd(sectionKey);
  const startIdx = existing.indexOf(start);
  const endIdx = existing.indexOf(end);
  if (startIdx === -1 || endIdx === -1 || endIdx <= startIdx) return '';
  return existing.slice(startIdx + start.length, endIdx).trim();
}

export function upsertJournalSection(existingMarkdown, sectionKey, newSectionContent) {
  const existing = existingMarkdown || '';
  const start = sectionStart(sectionKey);
  const end = sectionEnd(sectionKey);
  const trimmedContent = (newSectionContent || '').trim();
  const block = `${start}\n${trimmedContent}\n${end}`;

  const startIdx = existing.indexOf(start);
  const endIdx = existing.indexOf(end);
  if (startIdx !== -1 && endIdx !== -1 && endIdx > startIdx) {
    return `${existing.slice(0, startIdx)}${block}${existing.slice(endIdx + end.length)}`.trim() + '\n';
  }
  const separator = existing.trim() ? '\n\n' : '';
  return `${existing.trim()}${separator}${block}`.trim() + '\n';
}
